import React from 'react';
import Profile from './components/Profile';
import Card from './components/card';
import Data from './data'


function App() {

  const [cards, setCards] = React.useState(Data.map(function(dataitem) {                                           
    return <Card key={dataitem.id}
                cardIcon={dataitem.cardIcon}
                title={dataitem.title}
                currentTime={dataitem.timeframes.weekly.current}
                prevTime={dataitem.timeframes.weekly.previous}  />
  }));

  function handleTimeFrame(e) {
    let currentFrame;
    let prevFrame;
        setCards(Data.map(function(dataitem) {      
          if (e.target.dataset.id === 'daily')  {
              currentFrame = dataitem.timeframes.daily.current  
              prevFrame = dataitem.timeframes.daily.previous
              document.querySelector('span.active').classList.remove('active');
              e.target.classList.add('active');
          } else if (e.target.dataset.id === 'weekly') {
              currentFrame = dataitem.timeframes.weekly.current  
              prevFrame = dataitem.timeframes.weekly.previous
              document.querySelector('span.active').classList.remove('active');
              e.target.classList.add('active');
          }  else if (e.target.dataset.id === 'monthly') {
              currentFrame = dataitem.timeframes.monthly.current  
              prevFrame = dataitem.timeframes.monthly.previous
              document.querySelector('span.active').classList.remove('active');
              e.target.classList.add('active');
          }     
              return <Card key={dataitem.id}
                        cardIcon={dataitem.cardIcon}
                        title={dataitem.title}
                        currentTime={currentFrame}
                        prevTime={prevFrame} />
        })
    ) 
  };

  return (
    <main className="App">
      <Profile handleTimeFrame={handleTimeFrame} />
      {cards}
    </main>
  );
}

export default App;
